import * as React from "react";
import { memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditCardSimple = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 20,
		height: 14,
		x: 2,
		y: 5,
		rx: 2
	}), /* @__PURE__ */ _jsx("path", { d: "M2 10h20" })]
});
const Memo = memo(SvgCreditCardSimple);
export default Memo;
